export enum ActionTypes {
    ExcelTemplate = 'excelTemplate',
    Modal = 'modal',
    Trigger = 'trigger'
}